module.exports = __webpack_public_path__ + "static/media/photo142.a86250fd.jpg";